import { $ } from "../third-party-imports";
export function emptyAddressFilds(){
    $('.address-bumper-screen input[name="inputAddressBumper"]').val('');
    $('.address-bumper-screen input[name="inputAddressBumper2"]').val('');
    $('.address-bumper-screen input[name="inputcity1"]').val('');
    $('.address-bumper-screen select[name="inputstate1"]').val('');
    $('.address-bumper-screen input[name="inputZipCode1"]').val('');
}